// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { maxQtyValue } from "@bg/XDL/Utilities/inputValidation";
import { useEffect, useState } from "react";

const enterKey = 13;
const regexp = /^[0-9\b]+$/;

const isValidNumberic = (number: string) => {
    if (number === "") {
        // backspace or delete case
        return true;
    }
    return regexp.test(number);
};

const useAccessibleSubmit = (
    value: string,
    onSubmit: (value: string) => void,
    cartLoadedTime?: number,
    minValue?: number,
) => {
    const [stateValue, setValue] = useState(value);
    // <xng-change> prevent non-numeric values or values > 6-figures on input for quantity - this is only used for cartLine inputs
    const changeHandler = (event: any) => {
        if (!isValidNumberic(event.currentTarget.value) || parseInt(event.currentTarget.value, 10) > maxQtyValue) {
            event.preventDefault();
            return;
        }
        setValue(event.currentTarget.value);
    };
    // <xng-change>
    const keyDownHandler = (event: any) => {
        if (event.keyCode === enterKey) {
            event.stopPropagation();
            if (
                event.currentTarget.value !== "" &&
                isValidNumberic(event.currentTarget.value) &&
                parseInt(event.currentTarget.value, 10) <= maxQtyValue
            ) {
                onSubmit(stateValue);
            }
        }
    };

    const blurHandler = (event: any) => {
        if (event.currentTarget.value !== "" && parseInt(event.currentTarget.value, 10) <= maxQtyValue) {
            if ((minValue && parseInt(event.currentTarget.value, 10) >= minValue) || !minValue) {
                onSubmit(stateValue);
            } else {
                setValue(value);
            }
        } else {
            setValue(value);
        }
    };

    useEffect(() => {
        setValue(value);
    }, [value, cartLoadedTime]);

    return {
        value: stateValue,
        changeHandler,
        keyDownHandler,
        blurHandler,
    };
};

export default useAccessibleSubmit;
